// Import dayjs if not already imported
import dayjs from 'dayjs'

/**
 * Generates options for years ranging from the current year to 10 years ago, including an option for "10+".
 *
 * @returns {Array} Array of year options.
 */
export function generateYearOptions() {
    const currentYear = dayjs().year()
    const yearOptions = []

    for (let year = currentYear; year >= currentYear - 10; year--) {
        yearOptions.push({
            value: year.toString(),
            label: year.toString(),
        })
    }
    yearOptions.push({ value: '10+' })

    return yearOptions
}

/**
 * Get the first node from an edges object.
 *
 * @param {object} object
 * @returns {object}
 */
export function getFirstNode(object) {
    if (!object || typeof object !== 'object' || !object?.edges?.length) {
        return
    }

    return object.edges[0]?.node
}

/**
 * Get the first user error.
 *
 * @param {object} response
 * @returns {string}
 */
export function getFirstUserError(response) {
    if (!response.userErrors?.length) {
        return
    }

    return response.userErrors[0].message
}

export function capitalizeFirstLetter(str) {
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
}